/* global baseApi */
import axios from 'axios'
import i18n from "@/lang";
import {Toast} from 'vant';
import {getToken, removeToken} from '@/utils/auth'

const service = axios.create({
    baseURL: baseApi,
    timeout: 30000 // request timeout
})

service.interceptors.request.use(
    config => {
        config.headers['Content-Type'] = 'application/json;charset=UTF-8';
        config.headers['token'] = getToken();
        return config;
    },
    error => {
        console.log(error); // Debug信息
        return Promise.reject(error);
    }
);

// res interceptor
service.interceptors.response.use(
    response => {
        const res = response.data
        if (res.code === 300) {
            Toast.fail(res.msg)
            removeToken()
            location.hash = '#/login'
        }
        return res
    },
    error => {
        Toast.fail(i18n.t(error.message))
        return Promise.reject(error)
    }
)
export default service
